import { extname } from './extname';
export var FILE_TYPES_BY_EXTENSION = {
  'aac': 'AAC audio',
  'avi': 'AVI Video File',
  'bin': 'Binary Data File',
  'bz': 'BZip archive',
  'bzip2': 'BZip2 Archive',
  'css': 'CSS File',
  'csv': 'CSV Data File',
  'doc': 'Microsoft Word Document',
  'docs': 'Microsoft Word Document (XML)',
  'eot': 'MS Embedded OpenType File',
  'epub': 'Electronic Publication (eBook)',
  'gz': 'GZip Archive',
  'gzip': 'GZip Archive',
  'html': 'HTML File',
  'htm': 'HTML File',
  'ico': 'MS Icon File',
  'ical': 'iCalendar File',
  'ics': 'iCalendar File',
  'js': 'JavaScript File',
  'json': 'JSON Data File',
  'midi': 'MIDI Music File',
  'mid': 'MIDI Music File',
  'mp3': 'MP3 Audio File',
  'mpeg': 'MPEG Video File',
  'mpkg': 'Apple Installer Package',
  'ogg': 'OGG Audio File',
  'ogv': 'OGG Video File',
  'otf': 'OpenType Font File',
  'pdf': 'PDF Document',
  'ppt': 'Microsoft Powerpoint Slideshow',
  'pptx': 'Microsoft PowerPoint Slideshow',
  'rar': 'RAR Archive',
  'rtf': 'Rich Text File',
  'svg': 'SVG Vector Image',
  'tar': 'TAR File',
  'ttf': 'TrueType Font File',
  'text': 'Text File',
  'txt': 'Text File',
  'vsd': 'Visio Document',
  'wav': 'WAV Audio File',
  'webm': 'WEBM Audio File',
  'webp': 'WEBP Image',
  'tiff': 'TIFF Image',
  'tif': 'TIFF Image',
  'png': 'PNG Image',
  'bmp': 'Bitmap Image',
  'jpg': 'JPEG Image',
  'jpeg': 'JPEG Image',
  'gif': 'GIF Image',
  'woff': 'Web Open Font File',
  'woff2': 'Web Open Font File',
  'xhtml': 'XHTML File',
  'xls': 'Microsoft Excel Spreadsheet',
  'xlsx': 'Microsoft Excel Spreadsheet',
  'xml': 'XML File',
  'zip': 'Zip Archive',
  '7z': '7-Zip Archive'
};
export var fileType = function (filename) {
  var ext = extname(filename || '').replace(/\./, '').toLowerCase();
  return FILE_TYPES_BY_EXTENSION[ext] || "".concat(ext.toUpperCase(), " File");
};